import React from 'react';

import { Text } from '@qality/common-components/src/atoms/Text';
import { Issue } from '@qality/common-components/src/molecules/Issue';
import { FEATURE_FLAG } from '@qality/common-config';
import { ReportIssueCell } from '@qality/common-model';
import { StorageOfUniqueServices } from '@qality/common-service';
import { DEFAULT_TEST_TYPE } from '@qality/common-utils/src/TestType.const';

import { EmptyComponentContainerStyled } from './ReportColumn.styled';

type Props = {
  cell: ReportIssueCell;
};

export default function ReportIssueColumn({ cell }: Props): JSX.Element {
  if (!cell) {
    return (
      <EmptyComponentContainerStyled>
        <Text noData>No test cases</Text>
      </EmptyComponentContainerStyled>
    );
  }

  const issueKey = StorageOfUniqueServices.get('URLService').getIssueURL(
    cell?.key
  );

  if (cell.testType !== undefined) {
    const testType = FEATURE_FLAG.isPremium
      ? cell?.testType
      : DEFAULT_TEST_TYPE;
    return (
      <Issue
        issueKey={cell.key}
        issueLink={issueKey}
        title={cell.summary}
        testTypeProps={{
          testType: testType,
          isLoading: !testType,
          style: { paddingRight: '8px', paddingTop: '4px' },
        }}
      />
    );
  }

  return (
    <Issue
      issueKey={cell.key}
      issueLink={issueKey}
      title={cell.summary}
      iconSrc={cell.icon}
    />
  );
}
